<template>
    <section :id="id" class="s-insertion" :class="basicClassName">
        <div class="a-container">
            <a-label v-if="l10n.label" v-bind="l10n.label">
                {{ l10n.label.text }}
            </a-label>
            <a-dangerous-html
                v-if="l10n.title"
                tag="h2"
                class="title"
                :content="l10n.title"
            />
            <a-dangerous-html
                v-if="l10n.lead"
                tag="p"
                class="lead"
                :content="l10n.lead"
            />
            <a-dangerous-html
                v-if="l10n.bodyText"
                tag="p"
                class="text"
                :content="l10n.bodyText"
            />
            <a-dangerous-html
                v-if="l10n.description"
                tag="p"
                class="description"
                :content="l10n.description"
            />
            <div v-if="l10n.link" class="link-wrap">
                <a-link
                    v-bind="l10n.link"
                    :size="l10n.link.size || 'title'"
                    :accent="l10n.link.accent || true"
                    :type="isDarkTheme ? 'light' : 'regular'"
                />
            </div>
            <div v-if="l10n.button" class="button-wrap">
                <a-button
                    v-bind="l10n.button"
                    :type="l10n.button.type || 'main'"
                />
            </div>
        </div>
    </section>
</template>

<script>
import AButton from '@core/components/button/button.vue';
import ADangerousHtml from '@core/components/dangerous-html/dangerous-html.vue';
import ALabel from '@core/components/label/label.vue';
import ALink from '@core/components/link/link.vue';
import contentMixin from '@core/mixins/content.js';
import l10n from '@core/mixins/l10n.js';
import styleMixin from '@core/mixins/style.js';

export default {
    name: 'SInsertion',
    components: {
        ADangerousHtml,
        ALabel,
        ALink,
        AButton,
    },
    mixins: [l10n, contentMixin, styleMixin],
    props: {
        label: {
            type: Object,
            default: null,
        },
        description: {
            type: String,
            default: undefined,
        },
        link: {
            type: Object,
            default: null,
        },
        button: {
            type: Object,
            default: null,
        },
    },
    computed: {
        isDarkTheme() {
            return this.background === 'dark-blue';
        },
    },
};
</script>

<style lang="postcss" scoped>
.s-insertion {
    @mixin basic-slice-paddings;

    color: var(--av-nav-primary);
    text-align: center;

    &.s-slice_background {
        @mixin background;
    }

    &.s-slice_background_dark-blue {
        color: var(--av-inversed-primary);

        .description {
            color: var(--av-inversed-primary);
        }

        .title,
        .lead,
        .text,
        .description {
            &:deep(a) {
                color: var(--av-link-inversed);

                &:hover {
                    color: var(--av-link-inversed-hover);
                }
            }
        }
    }
}

.a-container {
    @media (--viewport-desktop) {
        @mixin colls 10;

        margin-inline: auto;
    }

    @media (--viewport-desktop-wide) {
        @mixin colls 8;
    }
}

.title {
    @mixin display-accent;

    @media (--viewport-mobile-wide) {
        @mixin hero-accent;
    }
}

.lead {
    @mixin lead-accent;

    margin-top: 24px;

    @media (--viewport-mobile-wide) {
        @mixin title-accent;
    }
}

.text {
    @mixin lead;

    margin-top: 24px;

    @media (--viewport-mobile-wide) {
        @mixin title;
    }
}

.description {
    @mixin paragraph;

    color: var(--av-fixed-secondary);
    margin-top: 24px;
}

.link-wrap {
    .a-link {
        margin-top: 40px;
    }
}

.button-wrap {
    .a-button {
        margin-top: 40px;
    }
}
</style>
